export const RemoteDays = [
  { title: '2 days', value: 2 },
  { title: '3 days', value: 3 },
  { title: '4 days', value: 4 },
]